// Internal Dependencies:
import { doRequest } from 'utilities/request'

export function openSearch() {
	return {
		type: 'OPEN_SEARCH'
	}
}

export function closeSearch() {
	return {
		type: 'CLOSE_SEARCH'
	}
}

export function setSearchInputDo( value ) {
	return {
		type: 'SEARCH',
		value
	}
}

export function setSearchInput( value ) {
	return function( dispatch, getState ) {
		const { isOpen } = getState().search

		if ( ! isOpen ) {
			window.scrollTo( 0, 0 )
		}

		dispatch( setSearchInputDo( value ) )
	}
}

export function searchLoading() {
	return { type: 'SEARCH_LOADING' }
}

export function requestingSearchData() {
	return { type: 'REQUESTING_SEARCH_DATA' }
}

export function receiveSearchData( json, args ) {
	return {
		type: 'RECEIVE_SEARCH_DATA',
		data: json,
		args: args
	}
}

export function receiveError( json ) {
	return {
		type: 'RECEIVE_ERROR',
		data: json
	}
}

export function getSearchData( searchTerm = false, args = false ) {
	return function( dispatch, getState ) {
		if ( ! searchTerm ) {
			searchTerm = getState().search.searchTerm
		}

		if ( searchTerm.length <= 1 ) {
			return
		}

		dispatch( requestingSearchData() )

		const { searchResults } = getState().search

		if ( ! args ) {
			args = {
				blockUI: true
			}
		}

		if ( args.blockUI ) {
			dispatch( searchLoading() )
		}

		const url = `${siteData.api_base_url}search/?search_term=${searchTerm}`

		return doRequest( url )
			.then( json => {
				dispatch( receiveSearchData( json, args ) )
			})
			.catch( error => {
				console.log( error, 'error' )
			})
	}
}
